import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { getColorClass, RATING_OPTIONS, RATING_DISPLAY_LABELS } from "../../utils/InputRatingUtils";

const RatingTableBody = ({
    activeColumnIndex,
    comments,
    contentItems,
    derivedExistingRatingsData,
    getGradingCriteriaId,
    groupData,
    handleCommentChange,
    handleOpenCommentModal,
    handleRatingChange,
    hasChanges,
    mode,
    ratings,
    selectedEpr,
    selectedTemplate,
    showComments,
    students
}) => {
    if (showComments) {
        return (
            <tbody>
                {students.map((student) => {
                    const gradingCriteriaId = getGradingCriteriaId(
                        student,
                        groupData,
                        selectedEpr,
                        selectedTemplate,
                        mode
                    );
                    const commentKey = `${student.key}_${gradingCriteriaId}`;
                    return (
                        <tr key={student.key}>
                            <td colSpan={contentItems.length}>
                                <textarea
                                    className="student-criteria-comment-input"
                                    disabled={student.isDisabled}
                                    style={{ width: "100%" }}
                                    value={comments[commentKey] || ""}
                                    onChange={(e) =>
                                        handleCommentChange(student.key, e.target.value, gradingCriteriaId)
                                    }
                                />
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        );
    }

    return (
        <tbody>
            {students.map((student) => (
                <tr
                    key={student.key}
                    className={student.isShared && student.groupPermission === "VIEW" ? "view-only-row" : ""}
                >
                    {contentItems.map((item, index) => {
                        const key = `${student.key}_${item.templateContentId}`;
                        const value = ratings[key] || "";
                        const existingRating = derivedExistingRatingsData
                            .find((r) => r.key === student.key)
                            ?.contentRatings?.find((cr) => cr.templateContentId === item.templateContentId);
                        const commentExists = existingRating?.comment?.trim();
                        const isNew = !student.contentRatings.find(
                            (cr) => cr.templateContentId === item.templateContentId
                        );

                        return (
                            <td
                                key={item.templateContentId}
                                className={index === activeColumnIndex ? "active-rating-col" : ""}
                            >
                                <div className="rating-cell">
                                    {student.isDisabled ? (
                                        <div className={classNames("view-only-rating", getColorClass(value))}>
                                            {" "}
                                            {RATING_DISPLAY_LABELS[value] || value || "Not Yet Rated"}
                                        </div>
                                    ) : (
                                        <select
                                            className={classNames(getColorClass(value))}
                                            disabled={student.isDisabled}
                                            value={value}
                                            onChange={(e) =>
                                                handleRatingChange(
                                                    student.key,
                                                    item.templateContentId,
                                                    e.target.value || null
                                                )
                                            }
                                        >
                                            <option value="">Select...</option>
                                            {RATING_OPTIONS.map((opt) => (
                                                <option key={opt} value={opt}>
                                                    {RATING_DISPLAY_LABELS[opt] || opt}
                                                </option>
                                            ))}
                                            <option value="">Clear Ratings</option>
                                        </select>
                                    )}
                                    {commentExists ? (
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip id={`tooltip-${student.key}-${item.templateContentId}`}>
                                                    {commentExists.length > 100
                                                        ? commentExists.slice(0, 100) + "..."
                                                        : commentExists}
                                                </Tooltip>
                                            }
                                        >
                                            <i
                                                className="comment-icon bi bi-chat-left-dots-fill"
                                                role="button"
                                                onClick={() => handleOpenCommentModal(student, item)}
                                                title="Edit Comment"
                                            />
                                        </OverlayTrigger>
                                    ) : (
                                        student.groupPermission !== "VIEW" &&
                                        !isNew && (
                                            <i
                                                className={`${getColorClass(value)}-icon comment-icon bi bi-chat-left-dots`}
                                                role="button"
                                                onClick={() => handleOpenCommentModal(student, item)}
                                                title="Add comment"
                                                style={
                                                    isNew && hasChanges ? { pointerEvents: "none", opacity: 0.5 } : {}
                                                }
                                            />
                                        )
                                    )}
                                </div>
                            </td>
                        );
                    })}
                </tr>
            ))}
        </tbody>
    );
};

RatingTableBody.propTypes = {
    activeColumnIndex: PropTypes.number,
    comments: PropTypes.object.isRequired,
    contentItems: PropTypes.array.isRequired,
    derivedExistingRatingsData: PropTypes.array.isRequired,
    getGradingCriteriaId: PropTypes.func.isRequired,
    groupData: PropTypes.array,
    handleCommentChange: PropTypes.func.isRequired,
    handleOpenCommentModal: PropTypes.func.isRequired,
    handleRatingChange: PropTypes.func.isRequired,
    hasChanges: PropTypes.bool.isRequired,
    mode: PropTypes.string.isRequired,
    ratings: PropTypes.object.isRequired,
    selectedEpr: PropTypes.object.isRequired,
    selectedTemplate: PropTypes.object.isRequired,
    showComments: PropTypes.bool.isRequired,
    students: PropTypes.array.isRequired
};

export default RatingTableBody;
